import { cn } from '@/lib/cn';

export function ColorSwatch({ hex, className }: { hex: string; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn('inline-block w-4 h-4 rounded-full border border-slate-300 shadow-2xs shrink-0', className)}
      style={{ backgroundColor: hex }}
    />
  );
}
